var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Chunk"},[(_vm.needsVideoTitle)?_c('h2',[_vm._v(_vm._s(_vm.video.title))]):_vm._e(),_c('div',{staticClass:"player-container"},[_c('div',{staticClass:"player"},[_c('div',{staticClass:"stick-player"},[_c('iframe',{attrs:{"id":"ytplayer","type":"text/html","width":_vm.iframeWidth,"height":"360","src":'https://www.youtube.com/embed/'
              + _vm.video.key
              + '?enablejsapi=1'
              + '&iv_load_policy=3'
              + '&modestbranding=1'
              + '&autoplay=1'

              /* https://developers.google.com/youtube/player_parameters */
              /* + '&version=3'
              + '&loop=1'
              + '&playlist=' + video.key */

              + _vm.playerVars,"frameborder":"0"}}),_c('ChunkBar',{attrs:{"width":_vm.iframeWidth,"duration":_vm.video.duration,"start":_vm.chunkComputed.start,"end":_vm.chunkComputed.end}}),_c('div',{},[_c('LoopControls',{attrs:{"disabled":_vm.chunkComputed.end <= _vm.chunkComputed.start,"loop":_vm.loop,"loopForever":_vm.loopForever},on:{"change":_vm.updateLoopState,"rewind":_vm.rewind}})],1)],1)]),_c('ChunkSiblings',{attrs:{"chunks":_vm.siblings,"current":_vm.chunkComputed}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }